import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

export type ArtistPostProfileAboutRequest = {
  profileId: string;
  data: { about: string };
};

export type ArtistPostProfileAboutParams =
  RequestConfig<ArtistPostProfileAboutRequest>;

export const artistPostProfileAbout = async ({
  params,
  config
}: ArtistPostProfileAboutParams) =>
  api.post(`/api/ArtistProfile/${params.profileId}/about`, params.data, config);
